// The account chip's avatar text, shared by `SiteHeader` and the app's chooser header
// (Story 8.10, ADO-2019, DV-37), so both chips read the same initials.

/** The first letter of the first two words that start with a letter ("Corrib Oil Ballina"
 *  → "CO"), or '' when none does (an account number). */
export function accountInitials(name: string): string {
  return name
    .split(/\s+/)
    .map((word) => Array.from(word)[0] ?? '')
    .filter((first) => /\p{L}/u.test(first))
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
